import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Team from '../components/Team';
import './Home.css';

function Home() {
  const location = useLocation();
  const [banMessage, setBanMessage] = useState('');

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const error = params.get('error');
    
    if (error === 'ip_banned') {
      setBanMessage('Your IP address has been banned from accessing this website. Contact support if you believe this is a mistake.');
    } else if (error === 'account_banned') {
      setBanMessage('Your account has been banned. Contact support for more information.');
    }
  }, [location]);

  return (
    <div className="home">
      {banMessage && (
        <div className="ban-alert">
          <div className="ban-alert-content">
            <span className="ban-icon">🚫</span>
            <p>{banMessage}</p>
            <button onClick={() => setBanMessage('')} className="close-alert">✕</button>
          </div>
        </div>
      )}
      
      {/* Hero Section */}
      <section className="hero-section">
        <div className="container">
          <div className="hero-content fade-in">
            <h1 className="hero-title">
              Premium FiveM & RedM Scripts
            </h1>
            <p className="hero-subtitle">
              High-quality, optimized scripts for your roleplay server
            </p>
            <div className="hero-buttons">
              <a href="/scripts" className="btn btn-primary">Browse Scripts</a>
              <a href="/documentation" className="btn btn-secondary">Documentation</a>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="features-section">
        <div className="container">
          <h2 className="section-title">Why Choose DevCore?</h2>
          <div className="features-grid">
            <div className="feature-card glass">
              <div className="feature-icon">🚀</div>
              <h3>Optimized Performance</h3>
              <p>All scripts are optimized for minimal server impact and maximum performance</p>
            </div>
            <div className="feature-card glass">
              <div className="feature-icon">🛡️</div>
              <h3>Secure & Reliable</h3>
              <p>Built with security best practices and thorough testing</p>
            </div>
            <div className="feature-card glass">
              <div className="feature-icon">📚</div>
              <h3>Full Documentation</h3>
              <p>Comprehensive guides and documentation for easy setup</p>
            </div>
            <div className="feature-card glass">
              <div className="feature-icon">💬</div>
              <h3>24/7 Support</h3>
              <p>Dedicated support team ready to help you anytime</p>
            </div>
          </div>
        </div>
      </section>

      {/* Team Section */}
      <Team />

      {/* CTA Section */}
      <section className="cta-section">
        <div className="container">
          <div className="cta-content glass">
            <h2>Ready to upgrade your server?</h2>
            <p>Browse our collection of premium scripts and take your server to the next level</p>
            <a href="/scripts" className="btn btn-primary">View All Scripts</a>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Home;
